import {
  postRegisterApi,
  checkUserApi,
  checkCompanyApi,
  getAllPlans,
  deleteCompanyApi,
  getLeadData,
} from "../../services/signUp";
import { getErrorObject, getErrorCode } from "../../utils/api.config";
import i18next from "i18next";
import * as types from "../types/index";

const verifyCard = (stripe, onSubmit, values, card) => {
  return async (dispatch) => {
    dispatch({ type: types.ADD_CARD });
    const payload = await stripe.createToken(card);
    if (payload.error) {
      dispatch({
        type: types.ADD_CARD_FAILURE,
        payload: { error: null },
      });
    } else {
      dispatch({
        type: types.ADD_CARD_SUCCESS,
        payload: { cardToken: payload },
      });
      onSubmit(values);
    }
  };
};

const resetStore = () => {
  return async (dispatch) => {
    dispatch({ type: types.RESET_SIGNUP_STORE });
  };
};

const saveSocialData = (data) => {
  return {
    type: types.SOCIAL_LOGIN_SUCCESS,
    payload: { data },
  };
};

const checkUser = (requestBody) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.GET_USER });
      await checkUserApi(requestBody);
      dispatch({ type: types.GET_USER_SUCCESS });
    } catch (error) {
      let errorCode = getErrorCode(error);
      let message = i18next.t("Authentication failed");
      if (errorCode) {
        switch (errorCode) {
          case 404:
            message = i18next.t("This user does not exist");
            dispatch({
              type: types.GET_USER_FAILURE,
              payload: { error: message },
            });
            return message;
          case 500:
          case 401:
          default:
            message = i18next.t("Authentication failed");
            dispatch({
              type: types.SERVER_ERROR,
              payload: { error: message },
            });
            break;
        }
      }
    }
  };
};

const checkCompany = (requestBody) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.GET_COMPANY });
      const response = await checkCompanyApi(requestBody);
      let message =
        response.status && response.status === 200
          ? "This company already exists in our system"
          : response.data || response.data.message
            ? response.data.message
            : "This company already exists in our system";
      dispatch({
        type: types.GET_COMPANY_SUCCESS,
        payload: { error: message },
      });
    } catch (error) {
      let errorCode = getErrorCode(error);
      let message = i18next.t("Authentication failed");
      if (errorCode) {
        switch (errorCode) {
          case 404:
            dispatch({
              type: types.GET_COMPANY_FAILURE,
              payload: { error: message },
            });
            break;
          case 500:
          case 401:
          default:
            message = i18next.t("Authentication failed");
            dispatch({
              type: types.SERVER_ERROR,
              payload: { error: message },
            });
            break;
        }
      }
    }
  };
};

const registerUser = (requestBody) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.REGISTERING_USER });
      const response = await postRegisterApi(requestBody);
      dispatch({
        type: types.REGISTERING_USER_SUCCESS,
        payload: {
          data: response.data,
        },
      });
    } catch (error) {
      let errorCode = getErrorCode(error);
      let message = i18next.t("Authentication failed");
      if (errorCode) {
        switch (errorCode) {
          case 500:
            message = i18next.t("Authentication failed");
            break;
          case 400:
            message = i18next.t("Authentication failed");
            break;
          case 401:
            message = i18next.t("Authentication failed");
            break;
          case 403:
            message = i18next.t("Access restricted");
            break;
          case 422:
            message =
              error.response.data.message ||
              "Something is missing. Please check";
            break;
          default:
            message = i18next.t("Authentication failed");
            break;
        }
      }
      if (message === "Your card was declined.") {
        dispatch({
          type: types.REGISTERING_USER_SUCCESS,
          payload: {
            data: { payment_intent: "requires_payment_method" },
          },
        });
      } else {
        dispatch({
          type: types.REGISTERING_USER_FAILURE,
          payload: { error: message },
        });
      }
    }
  };
};

const getAllPlanDetails = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.GET_SIGN_UP_PLANS });
      const response = await getAllPlans();
      dispatch({
        type: types.GET_SIGN_UP_PLANS_SUCCESS,
        payload: { data: response.data },
      });
    } catch (error) {
      let { message } = getErrorObject(error);
      if (message.includes("40")) {
        message = null;
      }
      dispatch({
        type: types.GET_SIGN_UP_PLANS_FAILURE,
        payload: { error: message },
      });
    }
  };
};

const deleteCompany = (token) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.DELETE_COMPANY });
      const response = await deleteCompanyApi(token);
      dispatch({
        type: types.DELETE_COMPANY_SUCCESS,
        payload: { data: response.data },
      });
    } catch (error) {
      let { message } = getErrorObject(error);
      dispatch({
        type: types.DELETE_COMPANY_FAILURE,
        payload: { error: message },
      });
    }
  };
};

const getLeadDetails = (token) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.GET_LEAD_DETAILS });
      const response = await getLeadData(token);
      dispatch({
        type: types.GET_LEAD_DETAILS_SUCCESS,
        payload: { data: response.data },
      });
    } catch (error) {
      let { message } = getErrorObject(error);
      if (message.includes("40")) {
        message = null;
      }
      dispatch({
        type: types.GET_LEAD_DETAILS_FAILURE,
        payload: { error: message },
      });
    }
  };
};

export const actions = {
  registerUser,
  verifyCard,
  saveSocialData,
  resetStore,
  checkUser,
  checkCompany,
  getAllPlanDetails,
  deleteCompany,
  getLeadDetails,
};
